import { type FC, useState } from 'react';
import { IoOptionsOutline } from 'react-icons/io5';
import RowOptionsDropdown from './RowOptionsDropdown';

import { rowOptionsStyle } from './styles';

interface Props {
	index: number;
	onAddRowClick: (_) => void;
	onDeleteRowClick: (_) => void;
}

const RowOptionsCell: FC<Props> = (props) => {
	const { index, onAddRowClick, onDeleteRowClick } = props;

	const [coords, setCoords] = useState({ top: 0, left: 0 });
	const [showDropdown, setShowDropdown] = useState(false);

	const handleRowOptionsClick = (e) => {
		const rect = e.target.getBoundingClientRect();

		setCoords({ left: rect.x + rect.width, top: rect.y + window.scrollY });
		setShowDropdown(!showDropdown);
	};

	const onClickOutside = () => {
		setShowDropdown(false);
	};

	return (
		<div className={rowOptionsStyle}>
			<IoOptionsOutline className="rowOptionsButton" onClick={(e) => handleRowOptionsClick(e)} />

			{showDropdown && (
				<RowOptionsDropdown
					coords={coords}
					index={index}
					onClickOutside={onClickOutside}
					onAddRowClick={onAddRowClick}
					onDeleteRowClick={onDeleteRowClick}
				/>
			)}
		</div>
	);
};

export default RowOptionsCell;
